import React, { Component } from 'react'
import './Answer.css'

export class Answer extends Component {
  videoAnswer() {
    if (this.props.gif) {
      return true
    } else {
      return false
    }
  }

  getClassNames() {
    const classes = ['answer']
    if (this.props.faded) {
      classes.push('faded')
    }
    if (this.videoAnswer()) {
      classes.push('gif')
    }
    return classes.join(' ')
  }

  render() {
    return (
      <div
        className={this.getClassNames()}
        // TODO: Detect the end CSS transition event instead
        // of setting a timer
        onClick={() => this.props.handleChange(this.props.id)}
      >
        {!this.videoAnswer() ? (
          <div dangerouslySetInnerHTML={{ __html: this.props.label }} />
        ) : (
          <img
            alt={this.props.label}
            style={{ width: '65%', height: 'auto' }}
            src={this.props.gif}
          />
        )}
      </div>
    )
  }
}
